/**@internal */
export var CustomAction;
(function (CustomAction) {
    CustomAction[CustomAction["PasswordRandomization"] = 4] = "PasswordRandomization";
    CustomAction[CustomAction["PasswordReset"] = 13] = "PasswordReset";
})(CustomAction || (CustomAction = {}));
//# sourceMappingURL=actions.js.map